// extracted by mini-css-extract-plugin
export default {"loader":"loading_down_styles_loader__0vvtJ","load1":"loading_down_styles_load1__BMSwG","loaderWrapper":"loading_down_styles_loaderWrapper__6Hu2H"};